import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { PhoneNumberRow } from '../types/phoneNumber';

type PhoneNumbersResponse = PhoneNumberRow[];
type DefaultError = unknown;

export function usePhoneNumbers<
  TData = PhoneNumbersResponse,
  TError = DefaultError,
>(
  options?: Omit<
    UseQueryOptions<PhoneNumbersResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<PhoneNumbersResponse, TError, TData>({
    queryKey: ['phone-numbers'],
    queryFn: async () => service.getPhoneNumbers(),
    ...options,
  });
}
